import {
  Activity,
  Archive,
  ArrowDownAZ,
  ArrowUpAZ,
  BriefcaseMedical,
  ClipboardList,
  Database,
  DatabaseBackup,
  DatabaseSearch,
  DatabaseZap,
  File,
  FileCheck,
  Files,
  FileStack,
  FileText,
  FolderOpen,
  Forward,
  Gauge,
  HeartPulse,
  Mail,
  Monitor,
  NotebookPen,
  Pill as PillIcon,
  Receipt,
  Search,
  Stethoscope,
  Syringe,
  Upload,
  UserPlus,
  Wind,
} from "lucide-react";

import { PILL_COLORS } from "components/ui/Pill";

export const ICON_OPTIONS = [
  { value: "Activity", label: "Activity", icon: Activity },
  { value: "Archive", label: "Archive", icon: Archive },
  {
    value: "BriefcaseMedical",
    label: "Briefcase Medical",
    icon: BriefcaseMedical,
  },
  { value: "ClipboardList", label: "Clipboard List", icon: ClipboardList },
  { value: "Database", label: "Database", icon: Database },
  { value: "DatabaseBackup", label: "Database Backup", icon: DatabaseBackup },
  { value: "DatabaseSearch", label: "Database Search", icon: DatabaseSearch },
  { value: "DatabaseZap", label: "Database Zap", icon: DatabaseZap },
  { value: "File", label: "File", icon: File },
  { value: "FileCheck", label: "File Check", icon: FileCheck },
  { value: "Files", label: "Files", icon: Files },
  { value: "FileStack", label: "File Stack", icon: FileStack },
  { value: "FileText", label: "File Text", icon: FileText },
  { value: "FolderOpen", label: "Folder Open", icon: FolderOpen },
  { value: "Forward", label: "Forward", icon: Forward },
  { value: "Gauge", label: "Gauge", icon: Gauge },
  { value: "HeartPulse", label: "Heart Pulse", icon: HeartPulse },
  { value: "Mail", label: "Mail", icon: Mail },
  { value: "Monitor", label: "Monitor", icon: Monitor },
  { value: "NotebookPen", label: "Notebook Pen", icon: NotebookPen },
  { value: "Pill", label: "Pill", icon: PillIcon },
  { value: "Receipt", label: "Receipt", icon: Receipt },
  { value: "Search", label: "Search", icon: Search },
  { value: "Stethoscope", label: "Stethoscope", icon: Stethoscope },
  { value: "Syringe", label: "Syringe", icon: Syringe },
  { value: "Upload", label: "Upload", icon: Upload },
  { value: "UserPlus", label: "User Plus", icon: UserPlus },
  { value: "Wind", label: "Wind", icon: Wind },
];

export const ICON_MAP = Object.fromEntries(
  ICON_OPTIONS.map((opt) => [opt.value, opt.icon])
);

export const BOOLEAN_COLORS = {
  YES: { color: "#006546", bg: "#e7efeb", border: "#006546" },
  NO: { color: "#26252c", bg: "#f1f1f3", border: "#d9d8df" },
};

export const DISABLED_COLORS = {
  ENABLED: { color: "#006546", bg: "#e7efeb", border: "#006546" },
  DISABLED: { color: "#b70000", bg: "#ffe8e8", border: "#b70000" },
};

export const STATUS_PILL_COLORS = {
  NEW: PILL_COLORS.docNew,
  IN_REVIEW: PILL_COLORS.docInProgress,
  REVIEWED: PILL_COLORS.docReviewed,
  UPLOADED: PILL_COLORS.docUploaded,
  SYSTEM_GENERATED: PILL_COLORS.docSystemGenerated,
};

export const STATUS_FILTER_OPTIONS = [
  { value: "NEW", label: "New" },
  { value: "IN_REVIEW", label: "In Review" },
  { value: "REVIEWED", label: "Reviewed" },
  { value: "UPLOADED", label: "Uploaded" },
  { value: "SYSTEM_GENERATED", label: "System Generated" },
];

export const FILTER_GROUPS = [
  {
    id: "defaultNewStatus",
    label: "Default Status",
    type: "multi",
    options: STATUS_FILTER_OPTIONS,
  },
];

export const SORT_OPTIONS = [
  {
    field: "name",
    direction: "asc",
    label: "Name (A-Z)",
    icon: ArrowDownAZ,
  },
  {
    field: "name",
    direction: "desc",
    label: "Name (Z-A)",
    icon: ArrowUpAZ,
  },
];
